module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1. Enslaved Men and Work"
    }
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_c('b', [_vm._v("Enslaved Men and Work")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("This chapter examines the everyday work spaces of enslaved men across the antebellum South. Enslaved men spent most of their day in the field, laboring in backbreaking conditions from sunup to sundown. Many—particularly those on large plantations—worked alongside other men in sex-segregated gangs, in which men usually plowed while women hoed. Together, these men lived intensive lives: they performed demanding labor for the owner and shared meals, commiserated together, and sang work songs. This chapter explores how the slaveholder organized gang labor and how the system shaped the lives of enslaved men across the antebellum South. It surveys the practices employed by planters on the sugar plantations of Louisiana; the tobacco, corn, and wheat fields of Virginia and North Carolina; the cotton plantations of the Southwest and Deep South; and the rice plantations of the Lowcountry. Enslaved men also toiled together in the homosocial spaces of southern industry. The involvement of enslaved people in southern industry is a subject generally neglected by historians, which is unfortunate because, typically, it was predominantly men who worked in this sector. In difficult conditions, enslaved men worked in factories, ironworks, mining, as well as the lumber and naval stores industries. They constructed the South’s infrastructure. Life was particularly hard: many were separated from their families and members of the opposite sex for most of the year as they labored in dangerous conditions. To survive, these men relied on and trusted one another; the bonds between them were strong. The chapter also analyzes the skilled work performed by enslaved men. Across the South, men undertook most of the skilled work available to enslaved people. Together, they took pride in their work and passed on their prized skills to younger men, creating an intergenerational male network. Working in homosocial spaces—whether on plantations, in industry, or in skilled work—enslaved men developed their own masculine work culture: ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“a way of doing things and a way of assigning values that flowed from the perspective that they had on Southern plantation life.”")]), _c('a', {
    attrs: {
      "id": "rch1en1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The homosocial world of enslaved men, for many, was born in the workplace. It was here, performing labor for their owners, that many enslaved men learned to cooperate and trust and depend on one another.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Plantation Work")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plantation slavery flourished throughout the South. Slaves labored on the lucrative cotton plantations of the Black Belt, which stretched from Georgia through Alabama and Mississippi to Louisiana and by the 1850s extended to Texas. In the swampy coastal regions of South Carolina and Georgia, large rice and indigo plantations prospered. Sugar production dominated the parishes of southern Louisiana, while tobacco plantations covered Virginia’s central and southern Piedmont and parts of North Carolina. Other staples—corn and wheat—grew throughout the South, the latter becoming an important cash crop in parts of Virginia and North Carolina. Some parts of the South, however—the great Appalachian heartland that stretched from western Virginia down to northeastern Alabama—were generally inhospitable to large plantation–scale slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slaves comprised 33 percent of the total southern population. Slave populations were high in the lower South. In 1860, black majorities in South Carolina and Mississippi comprised 57.2 percent and 55.2 percent of the respective state populations. Slave populations were 43.7 percent in Georgia, 44 percent in Florida, 45.1 percent in Alabama, and 46.9 percent in Louisiana. In contrast, the states of the upper South had considerably lower slave populations. About one third of Virginia and North Carolina’s population were enslaved, and a quarter in Tennessee and a fifth in Kentucky. Slaves accounted for 12.7 percent of the population in Maryland and a tiny 1.6 percent of inhabitants in Delaware. According to the 1850 census, the total slave population for the antebellum South was 3,204,313. Although many slaves worked in mixed farming, most of the enslaved labor force cultivated the great staple crops of the antebellum South. The census of 1850 estimates that out of the 2.5 million slaves working in agriculture, 1.815 million were engaged in cotton production, 350,000 in tobacco, 150,000 in sugar, 125,000 in rice, and 60,000 in hemp."), _c('a', {
    attrs: {
      "id": "rch1en2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slaveholders employed two distinct labor practices in the antebellum South: the task system and the gang system. Under the task system, each "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("slave was assigned a specific job for the day or week. After completing their assigned work, slaves were “free” to do as they pleased; usually, they returned home and tended small garden plots, performed housework, or went hunting. The task system was utilized extensively in the Lowcountry rice and Sea Island cotton regions of South Carolina and Georgia.")]), _c('a', {
    attrs: {
      "id": "rch1en3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Planters usually allotted tasks based on age and physical ability; they categorized individual men and women as quarter-, half-, three-quarter-, or full-task hands. On a visit to a large Lowcountry rice plantation, Frederick Law Olmsted observed the system firsthand:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_vm._v("The field-hands are all divided into four classes, according to their physical capacities. The children beginning as “quarter-hands,” advancing to “half-hands,” and then to “three-quarter-hands;” and, finally, when mature, and able-bodied, healthy, and strong, to “full hands.” As they decline in strength, from age, sickness, or other cause, they retrograde in the scale, and proportionally less labor is required of them. Many, of naturally weak frame, never are put among the full hands. Finally, the aged are left out at the annual classification, and no more regular field-work is required of them, although they are generally provided with some light, sedentary occupation."), _c('a', {
    attrs: {
      "id": "rch1en4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although under the task system the enslaved were treated as individuals and assigned individual work tasks, many continued to work in groups; the stronger and faster slaves helped the slower and weaker ones with work, allowing them to keep up with the group. As slave owner James Sparkman remarked in an 1858 letter, “it is customary ("), _c('i', [_vm._v("and never objected to")]), _vm._v(") for the more active and industrious hand to assist those who are slower and more tardy in finishing their daily tasks.”"), _c('a', {
    attrs: {
      "id": "rch1en5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under the gang system, slaveholders divided their workforce into groups under the supervision of a driver or leader and compelled them to work the entire day. Thus, the enslaved were not afforded the measure of independence available to those working under the task system. The gang system was commonly used on the tobacco plantations of the upper South, on most cotton plantations, and on the sugar plantations of southern Louisiana. As with the task system, planters rated the enslaved workforce as quarter hands, half hands, three-quarter hands, and full hands."), _c('a', {
    attrs: {
      "id": "rch1en6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under both systems, owners of large plantations divided their workforces into sex-segregated gangs. On small holdings, however, there were "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("simply not enough workers to permit planters to divide their workforce in this way. One WPA respondent, formerly enslaved on a small farm holding eight slaves in White County, Tennessee, claimed that “the women would plow, hoe corn, just like the men would.”")]), _c('a', {
    attrs: {
      "id": "rch1en7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Phoebe Lyons, enslaved in Lincoln County, Georgia, recalled that on her plantation “dey wuz’nt many slaves.” Accordingly, her mother “had to wuk en de fiel’ en plow jus’ like er man, en de res’ us chilluns big nuff ter pull weeds er swing er hoe, wuz out en er fiel’ wukin,’ fum daylight till too dark ter see.”"), _c('a', {
    attrs: {
      "id": "rch1en8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Enslaved in a small community in Buena Vista, Alabama, Adaline Montgomery remarked her mother’s master had only two slaves: one manservant and her mother. As a result, her mother “had to go out an’ work jes’ like a man, cut logs an’ split rails.”"), _c('a', {
    attrs: {
      "id": "rch1en9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Another former slave who worked on a small holding in West Virginia claimed her master “worked men or women slaves just alike.”"), _c('a', {
    attrs: {
      "id": "rch1en10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Historians estimate slaveholders needed upward of fourteen working hands before gangs could be organized."), _c('a', {
    attrs: {
      "id": "rch1en11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In 1860, planters possessing more than twenty slaves owned 48 percent of all enslaved people."), _c('a', {
    attrs: {
      "id": "rch1en12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Thus, almost half the slave population lived on plantations where it was possible to assign work by gender; the larger the plantation, the more likely that work was divided into sex-segregated gangs. In 1860, a quarter of the enslaved population lived on large plantations holding more than fifty slaves. The sugar plantations located along the banks of the lower Mississippi River and the coastal Lowcountry rice plantations of South Carolina and Georgia were the largest slaveholdings in the South."), _c('a', {
    attrs: {
      "id": "rch1en13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" In gangs, men undertook the more physically challenging task of plowing while women hoed."), _c('a', {
    attrs: {
      "id": "rch1en14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Slave owners were, of course, interested foremost in making a return on their investment. Accordingly, they did not hesitate to dissolve these sex-segregated gangs in response to specific labor requirements. For instance, during the busy harvesttime in the cotton fields, every hand was needed; hence it was not unusual for men and women to labor side by side picking cotton. Nevertheless, owners maintained that separating their workforce was advantageous: it prevented enslaved people from interacting and flirting and thus disrupting the work routine. Furthermore, men were prevented from helping women with quotas or protecting them from punishments."), _c('a', {
    attrs: {
      "id": "rch1en15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Large sugar plantations dominated the landscape of southern Louisiana. In Ascension Parish, half of all the enslaved population lived on plantations holding 175 or more slaves."), _c('a', {
    attrs: {
      "id": "rch1en16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Unlike planters who grew cotton, tobacco, or rice, sugar planters imported far more male than female slaves "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("in the domestic slave trade; 85 percent of all slaves who were sold to sugar plantations were male. Working on a sugar plantation was extremely physical; therefore, owners preferred a male workforce. Women were relatively scarce, and on some plantations, the ratio of enslaved men to women stood at almost three to one. According to historian Richard Follett, “the region mirrored the slave gulags of the Caribbean, where nineteenth-century sugar planters demonstrated a similar preference for males as agricultural workers.” As a result, Louisiana’s slave population suffered a natural decrease of about 13 percent per decade.")]), _c('a', {
    attrs: {
      "id": "rch1en17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given the gender ratio in Louisiana, many enslaved men would have faced difficulties in finding female partners; it is plausible that they attached more significance to homosocial relationships. Men, after all, worked from sunup to sundown in sex-segregated gangs on the large sugar plantations of Louisiana. The plow gang was distinctly male—comprising the strongest men. The hoe gangs included both men and women; however, men and women frequently worked in separate hoe gangs."), _c('a', {
    attrs: {
      "id": "rch1en18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" After a trip to the sugar plantations of Louisiana, William Russell Howard commented: “Three gangs of negroes were at work: one gang of men, with twenty mules and ploughs, was engaged in running through the furrows between the canes, cutting up the weeds, and clearing away the grass…. Another gang consisted of forty men, who were hoeing out the grass in Indian corn. The third gang, of thirty-six women, were engaged in hoeing out cane.”"), _c('a', {
    attrs: {
      "id": "rch1en19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Owners of large sugar plantations in Louisiana frequently organized their workforces according to gender for a variety of tasks. Franklin A. Hudson, owner of the Blythewood Plantation on Bayou Goula, Iberville Parish, often detailed the division of labor in his plantation diary. The following entries were typical: “7 men ditching in Road ditch x Women cutting hay”; “Men cutting down trees on Congress land—women cutting corn stalks”; and “women gang taking grass from plant cane, men cutting wood.”"), _c('a', {
    attrs: {
      "id": "rch1en20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Hudson commonly ordered gangs of enslaved men to undertake the more physically demanding work: digging ditches, cutting down and hauling wood. Work gangs of women cut sugar cane, hay, corn stalks, and cleaned the ditches and drains."), _c('a', {
    attrs: {
      "id": "rch1en21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Sixty miles north of New Orleans, situated on the banks of the Mississippi, was the St. James Sugar Refinery, owned by one of the antebellum South’s wealthiest planters: Valcour Aime. As on Hudson’s plantation, the enslaved workforce was divided: male gangs dug ditches and chopped and hauled wood, while female gangs cut weeds, gathered corn, repaired roads, and cleaned ditches."), _c('a', {
    attrs: {
      "id": "rch1en22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Enslaved men and women on the "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("large sugar plantations of Louisiana worked in homosocial spaces throughout the working day.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg24_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("On large plantations, many enslaved men and women worked in sex-segregated work gangs. In this scene, men work in the background, while women work together gathering the sugar cane. "), _c('i', [_vm._v("Gathering the Cane")]), _vm._v(", in T. B. Thorpe, “Sugar and the Sugar Region of Louisiana,” "), _c('i', [_vm._v("Harper’s New Monthly Magazine")]), _vm._v(" 7, no. 42 (November 1853): 760.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("As in Louisiana, on the large tobacco, wheat, and corn plantations of the Upper South, slaveholders divided their workforces by gender. Initially, in the seventeenth-century Chesapeake, enslaved workers in the tobacco fields toiled together at the same tasks in mixed-sex work groups; however, as planters increasingly diversified their plantations from the middle ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("of the eighteenth century—growing wheat and corn alongside tobacco—they organized sex-segregated work gangs. Slaveholders assigned a variety of tasks to enslaved men: sowing and mowing grain, plowing, harrowing, carting, ditching, lumbering, and fishing. Enslaved women worked in all-female gangs hoeing and weeding, building fences, grubbing swamps, cleaning winnowed grain, breaking up new ground, cleaning stables, and loading and spreading manure.")]), _c('a', {
    attrs: {
      "id": "rch1en23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Such trends continued into the antebellum period. On White Hill Plantation, located in Prince George County, Virginia, the enslaved harvested wheat, corn, and tobacco. The owner, Charles Friend, organized his workforce according to gender; in January 1846, he listed in his plantation diary the names of thirty-four male and twenty-nine female slaves. Friend frequently tasked the gangs of men to chop and haul wood and plow, and the women and children usually grubbed."), _c('a', {
    attrs: {
      "id": "rch1en24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" In some diary entries, Friend records that the women were occasionally joined by elderly enslaved men Jack and Dick, who as of January 1846 were sixty and sixty-five years old."), _c('a', {
    attrs: {
      "id": "rch1en25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" On other occasions, a slave named Billy worked with the women. Records document two slaves named William on the plantation, aged thirty-five and twenty-two as of January 1846. Additionally, a slave named Ned who was forty-five years old worked with the women on a few instances. As these men were not elderly, it plausible that they had been assigned places in the women’s work gangs as a result of injury or health."), _c('a', {
    attrs: {
      "id": "rch1en26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Burke and McDowell counties, North Carolina, James Hervey Greenlee raised a variety of crops—wheat, corn, cotton, and oats—as well as livestock such as hogs and cattle. According to the U.S. census, in 1850 Greenlee owned twenty-six slaves and approximately $16,000 of property. On his plantation, women gangs cut and cleaned up briars, dug potatoes, cut sprouts, and hoed and spun cotton, while male gangs plowed, hauled wood, and dug ditches."), _c('a', {
    attrs: {
      "id": "rch1en27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" On another North Carolina plantation, located in Franklin County, which produced tobacco, cotton and grain, owner Nicholas Bryor Massenburg also preferred to divide his labor force by gender. Children worked with the women, while men plowed and undertook the heavy work: chopping and hauling wood, and digging ditches. According to plantation records, no woman was instructed to dig ditches, work on the roads, or cut and collect timber."), _c('a', {
    attrs: {
      "id": "rch1en28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" On the large plantations of the upper South, enslaved men and women would have spent the majority—if not all—of the working day in same-sex gangs performing tasks assigned on the basis of gender.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Owners of large cotton plantations in the Southwest and the Lowcountry often divided their workforces by gender. Although they forced men and women to work side by side during the busy harvest season, for the rest of the year they tasked sex-segregated gangs to plant and cultivate the cotton plant.")]), _c('a', {
    attrs: {
      "id": "rch1en29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" As elsewhere, men usually plowed and women hoed. In Mississippi, women and children beat down the old plants in order to prepare the cotton crop. Male gangs then plowed the field to break up the soil and create furrows for cultivation. Women sowed the seeds and, afterwards, the men plowed light harrows to cover them. Hoe gangs then “scraped” the fields to prevent weeds and grass growing on the ridges while the seedlings sprouted. They also thinned the crop. Without delay, plow gangs then ran plows through the rows with a mould board, which threw dirt onto the plants. Hoe gangs followed chopping cotton. The hoe gangs performed occasional scraping until the crop was ready for harvest. During his visit to Mississippi, Frederick Law Olmsted observed that workers on a plantation of 135 slaves were divided into two gangs: male and female: “We found in the field thirty plows, moving together, turning the earth from the cotton plants, and from thirty to forty hoers, the latter mainly women.” Sometimes, both sexes worked together pulling stalks, and erecting fences; on other occasions women worked in their own gangs fencing. As well as plowing, male gangs worked together chopping and hauling wood."), _c('a', {
    attrs: {
      "id": "rch1en30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Indoor tasks assigned to enslaved men and women differed. Women spun, wove, knitted, and mended clothes; they sometimes ground corn into meal or hominy. Men shelled corn, thrashed peas, cut potatoes for planting, platted shucks, and cleaned the corn crib. If required, skilled men repaired plantation equipment."), _c('a', {
    attrs: {
      "id": "rch1en31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although plowing was men’s work on many plantations, Olmsted observed women plowing in large gangs on a cotton plantation in Mississippi. He admitted that he “watched with some interest for any indication that their sex unfitted them for the occupation”: “Twenty of them were plowing together with double teams and heavy plows. They were superintended by a male negro driver, who carried a whip, which he frequently cracked at them, permitting no dawdling or delay at the turning; and they twitched their plows around on the head-land, jerking their reins, and yelling to their mules, with apparent ease, energy, and rapidity.”"), _c('a', {
    attrs: {
      "id": "rch1en32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" But, in this case, although women undertook “men’s work,” the workers still worked in sex-segregated gangs; they remained in the company of their own sex throughout the working day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Planters in the cotton-growing regions of Georgia and South Carolina similarly divided their workforces by sex. Historian Susan O’Donovan has claimed that in southwest Georgia, “although the boundaries and categories were never absolute, more often than not the distinctions between men’s work and women’s work held steady.” Men performed the most physical tasks: they chopped down trees, hauled and mauled wood, prepared fertilizer, cut oats and wheat, wrestled cattle to the ground for branding and castration, packed cotton, and moved gin and milling machinery. In contrast, women chopped cotton, hoed weeds, spread manure on the fields, knocked down cotton stalks, burned brush, pulled fodder, dug potatoes, harvested vegetables, shucked grain, and strewed seed. As in Mississippi, women occasionally plowed in gangs. However, the plowing experiences of women in Georgia differed considerably from those of men. Unlike the heavy, iron, V-shaped plows used by teams of enslaved men, if called to plow in the late spring and summer, enslaved women used smaller, lighter contraptions called “scooters,” designed to only scratch the surface of the ground to uproot weeds and grass from between the growing crops.")]), _c('a', {
    attrs: {
      "id": "rch1en33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Edwin Fripp, owner of a large South Carolina Sea Island cotton plantation, sent only men to work in the swamps to chop and haul wood. On his plantation, the men plowed and dug ditches, while the women dug slips, burnt grass, listed, raked, and hoed. After the cotton was picked, the women assorted and moated the produce, and the men weighed it."), _c('a', {
    attrs: {
      "id": "rch1en34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Depending on the equipment available, ginning tended to be reserved for enslaved women."), _c('a', {
    attrs: {
      "id": "rch1en35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" On most large cotton plantations throughout the South, planters divided their workforces by gender. Men and women labored in sex-segregated spaces throughout the long working day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owners of large rice plantations in the Lowcountry often divided their enslaved workforces by gender; Olmsted remarked that “the field hands, are nearly always worked in gangs, the strength of a gang varying according to the work that engages it; usually it numbers twenty or more, and is directed by a driver.”"), _c('a', {
    attrs: {
      "id": "rch1en36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Gangs of women prepared the rice field by burning the stubble of the preceding crop. Duncan Clinch Heyward, member of one of the largest rice planting families of the Lowcountry, recalled:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_vm._v("Burning stubble was usually done by women, who dragged the fire with their hoes. When the stubble was thoroughly dry and a stiff breeze blowing, they sometimes had to jump across the quarter ditches to avoid the advancing fire. There was considerable excitement in this "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("work, and the women seemed to enjoy it. Their dresses were tied up to their knees and did not hinder them from jumping the ditches when they were caught in a close place by the fire. “Look out, Sister!” they would often call to each other. “Don’t let dat fire ketch ’ona. Jump across de ditch.”")]), _c('a', {
    attrs: {
      "id": "rch1en37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("After the burning and plowing, women hoed to level and prepare the soil; they pulled up weeds and spread manure to fertilize the land. Elizabeth Pringle, who grew up on one of the largest slave plantations in South Carolina, commented that the male laborers associated the hoe with female work: “The hoe they consider purely a feminine implement.”"), _c('a', {
    attrs: {
      "id": "rch1en38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Planting the rice seed—the next stage—was also customarily regarded as women’s work. According to Heyward, women always planted the rice seeds. He commented, “Women always did this work, for the men used to say that this was ‘woman’s wuck,’ and I do not recall seeing one of the men attempt it.”"), _c('a', {
    attrs: {
      "id": "rch1en39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Men and women, however, did work together on some tasks—processing rice, for example. Enslaved men and women also cleaned ditches together. But, almost always, only male gangs dug ditches."), _c('a', {
    attrs: {
      "id": "rch1en40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Slaveholder James R. Sparkman described the practice on his plantation: “In the preparation of the Rice Lands, as ditching, embanking etc. the "), _c('i', [_vm._v("men")]), _vm._v(" alone are engaged with the spade.”"), _c('a', {
    attrs: {
      "id": "rch1en41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" As on other large plantations throughout the antebellum South, men chopped and hauled wood."), _c('a', {
    attrs: {
      "id": "rch1en42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even when men and women labored together—cleaning ditches and processing rice—they worked in separate spaces."), _c('a', {
    attrs: {
      "id": "rch1en43"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" In fact, throughout the long working day, most men and women on large Lowcountry rice plantations worked in different spaces. When Olmsted visited one of these, he noted that it was divided by embankments into fields of about twenty acres each. In one field, he observed a gang of twenty to thirty women raking and burning stubble. In the next, twenty young men and boys plowed. Olmsted presumed that the men had half an hour for breakfast, which was taken together “in a social company about a fire.” He observed that in one upland field a gang comprised “entirely of men” ditched; in another field, a female gang hoed a corn field. Each gang “had a fire burning on the ground, near where they were at work, to light their pipes and warm their breakfast by.”"), _c('a', {
    attrs: {
      "id": "rch1en44"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Each sex-segregated gang spent all day together working and sharing precious little breaks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the sugar plantations of Louisiana; to the Virginia and North Carolina tobacco, wheat, and corn fields; to the cotton belts of the Southwest "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("and Deep South; and to the rice fields of the Lowcountry, slaveholders of large plantations routinely divided their workforce into sex-segregated gangs. Usually, men plowed and women hoed. Even if assigned similar jobs, enslaved men and women still found themselves in sex-segregated gangs. Although women plowed on occasion, enslaved men were able to claim a distinct gendered identity in the field because their owners generally regarded male labor as “superior,” typically assigning men the most physically arduous tasks.")]), _c('a', {
    attrs: {
      "id": "rch1en45"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Indeed, telling are the responses of many former slaves who regarded plowing, ditching, or working wood as man’s work."), _c('a', {
    attrs: {
      "id": "rch1en46"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Working all day together would have strengthened masculine camaraderie. In the field, these men suffered together, took breaks and ate their food together, and, most likely, commiserated with one another.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Industrial Work")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although the South’s economy was predominantly agricultural, by the beginning of the nineteenth century certain industries—such as crop processing, manufacturing, and transportation enterprises—had begun to develop. Industrialization accelerated in towns such as Richmond, and industrial output increased accordingly. By 1860, about 15 percent of America’s industrial capacity was centered in the South. Slave labor was extensively employed; in the 1850s about 5 percent of the total slave population, between 160,000 and 200,000, worked in various kinds of industry. Slaves worked in southern textile, sugar, grist, and rice mills; iron and salt works; tobacco and hemp factories; coal, gold, lead, and iron mines; fisheries; and the lumber and turpentine industries. They built the South’s infrastructure—railroads, roads, and canals. They worked in construction and on steamboats as deck hands, firemen, engineers, and even pilots. Although some industrial slaves were women and children, the vast majority were men."), _c('a', {
    attrs: {
      "id": "rch1en47"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Industry was a mostly masculine world. Indeed, enslaved men who worked in the naval stores or lumber industries or on the railroads and canals lived in isolated areas, cut off from their families for most of the year. Living, socializing, and working together under particularly dangerous conditions, these men forged strong bonds of solidarity and developed an interdependent masculine work culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slaves comprised the majority of the workforce in the upper South ironworks. In Maryland and Virginia, eighty ironworks employed slave labor by the nineteenth century. Collectively, the ironworks of the Upper "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("South utilized seven thousand workers between 1800 and 1860.")]), _c('a', {
    attrs: {
      "id": "rch1en48"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Some of the well-known establishments, such as the Oxford Iron Works of Virginia, owned 220 slaves. On the eve of the Civil War, the Tredegar Iron Company of Richmond employed a total of 900 workers, half of whom were enslaved."), _c('a', {
    attrs: {
      "id": "rch1en49"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" The manufacture of iron was labor-intensive, and therefore many slaves who worked in iron production were men."), _c('a', {
    attrs: {
      "id": "rch1en50"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Together, these men chopped wood, manned charcoal pits, hauled charcoal long distances, mined iron ore, and extracted limestone. Day and night, in dirty, sweaty, noisy conditions, the teams fed the blast furnaces with iron ore, charcoal, and limestone into blast furnaces. At the forge, gangs of slave heaters and hammermen turned pig iron into merchant bars (refined iron that had been hammered into standard-sized bars)."), _c('a', {
    attrs: {
      "id": "rch1en51"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Women and children worked in a variety of operations: William Weaver’s Buffalo Forge near Lexington, Virginia; David Ross’s Oxford Iron Works; and the Tredegar Iron Works. In these large-scale operations, they labored separately from men as plantation hands and assistants in the charcoal-making process. They raked leaves, which were used with dirt to cover smoldering wood and convert it to charcoal. Women also cleaned and picked over the ore to free it from impurities before it went to the furnace. Although records suggest that women did work at the furnace and forge, no records exist through which to ascertain their precise roles."), _c('a', {
    attrs: {
      "id": "rch1en52"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men worked in distinctly homosocial spaces in mines. In 1820, the United States was rated sixth in the world for coal production, and three-quarters of the nation’s exports came from the mines of southwestern Virginia, western Maryland, and West Virginia. By 1860, two-thirds of the 3,579 Appalachian coal miners in 1860 were enslaved workers."), _c('a', {
    attrs: {
      "id": "rch1en53"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" In contrast to the iron industry, whereby many slaves were owned by the various iron manufacturing enterprises, coal mines tended to hire their hands. In an almost exclusively male enterprise, “coal miners never had the female component frequently found at ironworks…. If the men had families, they resided elsewhere.”"), _c('a', {
    attrs: {
      "id": "rch1en54"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The census of 1860 showed that no females worked at the Midlothian mines in Virginia. Only one female slave was listed as a worker among a workforce of sixty-six at the Clover Hill Coal Mining Company, near Petersburg."), _c('a', {
    attrs: {
      "id": "rch1en55"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" If employed at the coal mines, female slaves most likely cooked and cleaned for the pitmen."), _c('a', {
    attrs: {
      "id": "rch1en56"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" As with the iron industry, coal companies implemented overwork systems whereby enslaved men could earn extra money for themselves and their families, thus enabling them to fill economic provider roles for their families. The money paid for "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("overtime varied among the different coal companies. One newspaper article reported that in the Midlothian mines “many of the slaves lay up $50 per annum for work done out of the regular hours.”")]), _c('a', {
    attrs: {
      "id": "rch1en57"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coal mining in the antebellum South was exceedingly dangerous. Enslaved miners faced the daily horrors of collapsing tunnels, explosions, fires, flooding, and suffocation. In March 1855, for example, an explosion at the Midlothian mines “broke down a partition wall between the pit in which the miners were at work,” resulting in the deaths of “five white men, two white boys, and thirty colored men.”"), _c('a', {
    attrs: {
      "id": "rch1en58"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" More than likely, a strong camaraderie united these male workers. Studies have shown that camaraderie “appears to be a universal element found in all mining communities throughout history.” For miners, the strong sense of fellowship serves as a vital support system in their everyday working lives and also as a means of survival in the event of an accident or disaster. Working in dangerous conditions, miners have to take responsibility for each other’s safety. The unwritten code dictates that miners always watch out for each other; in the case of an accident, they know they are able to rely on their fellow workers to do everything possible to make sure they all get out safely. As one twentieth-century miner from Kentucky remarked, “Miners is about the closest people to each other that you’ll ever find … they know what each other has been through.”"), _c('a', {
    attrs: {
      "id": "rch1en59"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mines were, and mostly still are, resolutely masculine spaces. Like most miners around the world, Appalachians were superstitious: they believed a woman’s presence in a mine brought bad luck. In fact, as the United States industrialized, such superstition led seventeen states to pass laws forbidding women from working underground in the mines."), _c('a', {
    attrs: {
      "id": "rch1en60"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Cornish miners, who worked alongside the enslaved in the Gold Hill gold mine of antebellum North Carolina, shared this superstition."), _c('a', {
    attrs: {
      "id": "rch1en61"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" In Gold Hill, men drilled, mined, and hauled lumps of rock; women worked aboveground and operated the log rockers that rewashed ore waste from the mills—they also washed and sewed."), _c('a', {
    attrs: {
      "id": "rch1en62"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Collectively, the gold mines of North Carolina produced tens of millions of dollars of America’s wealth. Many utilized slave labor."), _c('a', {
    attrs: {
      "id": "rch1en63"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" As with most extractive industries, it was a labor-intensive enterprise involving mostly men. Fraternity and friendship flourished among the North Carolina miners: one white miner wrote in a letter, “When I left [Asheboro] and went to Gold hill I soon contracted friendships as pure and strong and lasting as in earlier life and never have I experienced greater pleasure … than in getting back to Gold Hill.” At Gold Hill “there is a set of "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("such brotherly, warm-hearted, wholesouled fellows …, that any one would become attached to.” Whatever ties of friendship and fraternity that existed among the miners, it most likely found expression within the boundaries of different ethnic groups. Whether or not these ties extended across racial and ethnic boundaries, it is likely that the same camaraderie existed among the enslaved African American male gold miners. By 1850, half of the miners and laborers at Gold hill were single men who lived in boardinghouses.")]), _c('a', {
    attrs: {
      "id": "rch1en64"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" They slept and worked together, and at the end of the working day, they most likely shared a drink, a joke, and a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men worked extensively in the naval stores industry, producing tar, turpentine, and their derivatives (turpentine spirits, rosin, and pitch). North Carolina led the way in production and by 1840 produced 95.9 percent of the naval stores in America. According to one report, in 1847 the state produced 800,000 barrels of turpentine, which had an estimated market value of $1.7 million to $2 million. Originally dominated by small farmers, by the late antebellum period the naval stores industry’s labor force consisted chiefly of slaves."), _c('a', {
    attrs: {
      "id": "rch1en65"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Most of the work, such as boxing, chipping, and cornering, required considerable strength, and hence enslaved men dominated the work force. If enslaved women and children were employed in the industry, they carried out the lighter task of “dipping.”"), _c('a', {
    attrs: {
      "id": "rch1en66"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" The task system structured work in the turpentine industry deep in the pine forests of southeastern North Carolina. Taking advantage of transportation improvements in the mid-nineteenth century, producers moved their operations, equipment, and labor force into isolated work camps. Here, enslaved men lived cut off from agricultural plantation life, denied regular contact with their families."), _c('a', {
    attrs: {
      "id": "rch1en67"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Some scholars have speculated that the uneven sex ratio left workers “lonely and miserable.” Accordingly, it is highly likely that the men turned to one another for support and friendship to survive life in the forests of North Carolina."), _c('a', {
    attrs: {
      "id": "rch1en68"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The southern lumber industry, based in the forests, was an exclusively masculine enterprise. Workers cut and sawed timber, shingles, and barrel staves. Lumbering was so widespread in the Carolinas that by 1845 Wilmington alone supported at least nine steam sawmills. Slave labor was used to log the pine, cypress, and oak trees in the swamps and forests of the South. By 1860, the southern lumber industry employed about 16,000 workers, most of whom were enslaved."), _c('a', {
    attrs: {
      "id": "rch1en69"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" When Frederick Law Olmsted visited the Great Dismal Swamp, he reported that the work in the swamp was “entirely done by slaves,” who were usually hired by the lumber companies for an average of $100 a year. Apart from one or two months in winter spent at their masters’ residences, these workers labored throughout the year deep in the swamp. Olmsted noted that when the swamp was dry, typically in early February, the enslaved entered it in gangs: each worker was “examined and registered at the Court-house, and ‘passes,’ good for a year, are given them, in which their features and the marks upon their persons are minutely described.”"), _c('a', {
    attrs: {
      "id": "rch1en70"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Fortunately, records such as those mentioned by Olmsted still exist today. They offer the historian valuable insights into who exactly worked in gangs cutting and hauling lumber deep in the forest and swamps of the antebellum South. In the North Carolina State Archives, a registration book of slaves exists that lists and describes hundreds of slaves who worked in the Dismal Swamp from 1847 to 1861. All of the legible entries in the book describe enslaved men. Unsurprisingly, given the labor-intensive nature of lumbering, most were strong, young men in their twenties and thirties."), _c('a', {
    attrs: {
      "id": "rch1en71"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" As Moses Roper recalled when his owner sent him to cut trees in a swamp, it was “the heaviest work which men of twenty-five or thirty years of age have to do.”"), _c('a', {
    attrs: {
      "id": "rch1en72"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Not all of the men listed in the registration book, however, were in their twenties and thirties; a young boy of only twelve and an older man of sixty were both sent to the swamp to work. One can only speculate what their precise roles were. Perhaps the young boy carried water to the workers and the elderly man cooked, cleaned, and looked after the camp while the rest were at work. It is, however, possible to observe that the hundreds of male workers in the swamp were part of an intergenerational interdependent network. Performing highly dangerous labor, they relied on one another for their lives, while others—too young or too old—served the community in other ways. Older men, for example, most likely served as father figures and role models for young boys, performing the roles of surrogate father and brother."), _c('a', {
    attrs: {
      "id": "rch1en73"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg33_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Slaveholders selected enslaved men to work as lumbermen in the Great Dismal Swamp. Although the work was extremely physical, lumbermen enjoyed a degree of relative autonomy far from plantation supervision. Long-term passes, such as this one, were issued to men to allow them to work in the swamp. These recorded in detail the particulars of each enslaved man. Available in Gates County Criminal Actions Concerning Slaves Records. (Courtesy of the North Carolina Office of Archives and History, Raleigh, North Carolina.)")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg34_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Author and illustrator David Hunter Strother (known by his pseudonym, Porte Crayon) visited the Great Dismal Swamp and in 1856 published sketches made during his trip, of enslaved men working and living together. He observed young boys transporting shingles in carts, like this one. Porte Crayon, "), _c('i', [_vm._v("Carting Shingles")]), _vm._v(", in “The Dismal Swamp,” "), _c('i', [_vm._v("Harper’s Monthly Magazine")]), _vm._v(" 13, no. 76 (September 1856): 450.")])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('div', {
    staticClass: "cap"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg35_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("During his visit to the Great Dismal Swamp, David Hunter Strother stopped at the headquarters of the swamp’s shingle-makers. He remarked: “Although of the rudest character, there seemed to be every material for physical comfort in abundance. There was bacon, salt fish, meal, molasses, whisky, and sweet potatoes.” Porte Crayon, "), _c('i', [_vm._v("Horse Camp")]), _vm._v(", in “The Dismal Swamp,” "), _c('i', [_vm._v("Harper’s Monthly Magazine")]), _vm._v(" 13, no. 76 (September 1856): 449, 451 (quotation).")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Enslaved lumbermen worked under the task system without a driver and were required to provide a certain quantity of shingles at the end of their service in the swamps. They led independent lives in a distinctly masculine world. As Olmsted remarked, “the slave lumberman … lives measurably as a free man; hunts, fishes, eats, drinks, smokes and sleeps, plays and works, each when and as much as he pleases.”")]), _c('a', {
    attrs: {
      "id": "rch1en74"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Workers lived in very close proximity to each other. One observer described their living arrangements: “Their houses, or shanties, are barely wide enough for five or six "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("men to lie in, closely packed side by side—their heads to the back wall, and their feet stretched to the open front, close by a fire kept up through the night. The roof is sloping to shed the rain, and where highest, not above four feet from the floor. Of the shavings made in smoothing the shingles, the thinnest make a bed for the laborers, and the balance form the only dry and solid foundation for their house, and their homestead, or working yard.”")]), _c('a', {
    attrs: {
      "id": "rch1en75"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men labored together to build the South’s infrastructure. During the antebellum period, thousands of workers were needed to construct the rail network throughout the South. The scale of the projects was huge, and southern railroads relied upon enslaved labor. By 1861, 76 percent of the 118 antebellum southern railroads employed enslaved labor. Most railroads purchased their own slaves, hired them, or contracted companies who hired them out. Although some historians have cited cases of women working on the railroads, the enslaved laborers were overwhelmingly male."), _c('a', {
    attrs: {
      "id": "rch1en76"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" With little mechanical help available, railroad building in the antebellum period was especially labor-intensive. Workers hauled earth, gravel, timber, and stone in carts and wagons; animals dragged plows and scrapers to grade the earth. Men with picks hacked at embankments, hills, and rocks. Men with axes swung at trees, chopped them, and made crossties. Hand-driven spikes fastened the iron rails into position."), _c('a', {
    attrs: {
      "id": "rch1en77"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" In this intense environment, a distinct masculine work culture developed. According to former slave Fannie Berry, enslaved men arrived for work at daybreak with axes on their shoulders to clear trees for the rail tracks in Appomattox County, Virginia. They sung this song:")]), _vm._v(" "), _c('p', {
    staticClass: "quotea"
  }, [_vm._v("A col’ frosty mo’nin,’")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("De niggers mighty good,")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("Take yo’ ax upon yo’ shoulder,")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("Nigger, TALK to de wood.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Berry remembered how the woods echoed as hundreds of workers sang and swung their axes in unison: “Dey be lined up to a tree, an’ dey sing dis song to mark de blows. Fust de one chop, den his pardner, an’ when dey sing TALK dey all chop together; an’ perty soon dey git de tree ready to fall an’ dey yell ‘Hi’ an’ de niggers all scramble out de way quick ’cause you can’t never tell what way a pine tree gonna fall.” Occasionally, she remarked, the workers sung a different song:")]), _vm._v(" "), _c('p', {
    staticClass: "quotea"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Dis time tomorrow night,")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "quote"
  }, [_vm._v("Where will I be?")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("I’ll be gone, gone, gone,")])]), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Down to Tennessee.")]), _c('a', {
    attrs: {
      "id": "rch1en78"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Cut off from regular plantation life, enslaved workers lived in makeshift shanty camps along the railroad, near their work. One observer described the cramped conditions of enslaved men who worked on the Manchester & Wilmington line and commented that they rarely saw women and were separated from their families:")]), _vm._v(" "), _c('p', {
    staticClass: "quotet"
  }, [_vm._v("The railroad hands sleep in miserable shanties along the line. Their bed is an inclined pine board—nothing better, softer, or warmer…. The temperature of the cabin, at this season of the year (November), is bitterly cold and uncomfortable. I frequently awoke, at all hours, shivering with cold, and found shivering slaves huddled up near the fire…. Poor fellows! in that God-forsaken section of the earth they seldom see a woman from Christmas to Christmas. If they are married men, they are tantalized by the thought that their wives are performing for rich women of another race those services that would brighten their own gloomy life-pathway. They may, perhaps—who knows?—have still sadder reflections."), _c('a', {
    attrs: {
      "id": "rch1en79"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canal workers faced similar conditions. Digging canals was backbreaking physical work requiring strong men. As historian David Cecelski has remarked, it was “the cruelest, most dangerous, unhealthy, and exhausting labor in the American South.”"), _c('a', {
    attrs: {
      "id": "rch1en80"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Unsurprisingly, most southern canals—the Brunswick and Altamaha, the Muscle Shoals, and the Dismal Swamp, for example—were dug by enslaved men."), _c('a', {
    attrs: {
      "id": "rch1en81"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Many canal companies owned their enslaved workforce. Those that sought to hire them placed advertisements in local newspapers. In 1848, an advertisement required “150 ABLE BODIED NEGRO MEN” to work on the James River and Kanawha Canal. The notice attempted to alleviate slaveholders’ fears of the notorious working conditions of canal workers: “We will feed and house the hands well, and will also pay the Doctors’ bill, if any. We believe our work and location is as healthy as any portion so the state … and have not had a solitary case of fever…. Our work is unusually light and dry, and but little risk to encounter; and our Shanties are of the best kind.”"), _c('a', {
    attrs: {
      "id": "rch1en82"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" This was not the experience "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("of Moses Grandy, who commented on the working conditions for enslaved men on the Dismal Swamp Canal: “The labor there is very severe. The ground is often very boggy: the negroes are up to the middle or much deeper in mud and water, cutting away roots and baling out mud: if they can keep their heads above water, they work on.” Grandy also remarked on the living conditions of the enslaved workforce: “They lodge in huts, or as they are called camps, made of shingles or boards. They lie down in the mud which has adhered to them, making a great fire to dry themselves, and keep off the cold. No bedding whatever is allowed them; it is only by work done over his task, that any of them can get a blanket.”")]), _c('a', {
    attrs: {
      "id": "rch1en83"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" As in the railroad, turpentine and lumber industry, these men lived in separate, allmale work camps, cut off from the opposite sex and their families."), _c('a', {
    attrs: {
      "id": "rch1en84"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Usually, they were permitted only very limited visiting rights to see their wives and families. Particularly revealing is the correspondence of a slave owner, Iverson L. Twyman of Virginia, who regularly hired out his slaves to work on the canals and railroads. At the beginning of 1851, he arranged for one of his slaves, Gilbert, to visit his wife only “three times in a year, with an allowance of nine days at each time.” This was apparently a generous arrangement—Twyman believed he was doing the couple a favor so “they may be better satisfied.”"), _c('a', {
    attrs: {
      "id": "rch1en85"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Separated from their loved ones, canal workers soon learned to depend on one another as they dug day after day in boggy, dangerous, disease-ridden conditions. Sometimes they exhibited exceptional displays of solidarity in the most miserable circumstances. At Juniper Bay, North Carolina, the overseer spent an entire day whipping every single canal worker because none would identity the slave who had stolen his fowl. None confessed or informed on their workmates."), _c('a', {
    attrs: {
      "id": "rch1en86"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men worked together as fishermen. In 1835, around 8,000 slaves worked for the Potomac River fisheries. In 1850, approximately 5,000 enslaved and free African Americans worked along the Albemarle Sound. The Albemarle commercial shad, rockfish, and herring seine fisheries relied heavily on enslaved labor. Gangs of enslaved men fished, while women and children gutted and cleaned the fish on the shore."), _c('a', {
    attrs: {
      "id": "rch1en87"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" The lack of large commercial fisheries meant that most enslaved fishermen worked after their masters’ cotton was hoed or tobacco was cut. These men usually fished for themselves, their masters’ families, and for local barter, rather than commercial purposes. Fishermen worked in small gangs or alone—often in remote places. Life was dangerous, and little profit was made. However, enslaved fishermen enjoyed the independence of their job."), _c('a', {
    attrs: {
      "id": "rch1en88"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Former slave "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Charles Ball recalled the autonomy and camaraderie enjoyed by fishermen while they operated a shad fishery for their master during spring. Initially supervised by a white fisherman, Ball and three other enslaved fishermen were left to their own devices while seining at night. Separated from the rest of the enslaved on his master’s cotton plantation, Ball and his team worked, slept, and ate together. Ball recalled, “We all lived well, and did not perform more work than we were able to bear.” He also traded some of the shad they caught for a supply of bacon, enabling him and his companions to live “sumptuously … unmolested by our master.” Ball revealed the bond he felt to one of his fellow fisherman: “He was a good natured, kind hearted man, and did many acts of benevolence for me, such as one slave is able to perform for another, and I felt a real affection for him.”")]), _c('a', {
    attrs: {
      "id": "rch1en89"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men worked together in factories across the South, processing plantation crops. Hired male slaves comprised the majority of the workforce in the tobacco factories of Virginia and North Carolina. By 1860, 12,843 slaves worked in this industry. In 1850, 90 percent of the enslaved workforce was male. The few women who worked in tobacco factories were stemmers (they removed the midribs from the tobacco leaves) or cooks, while the men performed the arduous task of pressing."), _c('a', {
    attrs: {
      "id": "rch1en90"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" As in the ironworks and coal mines, companies paid slaves for overtime. Enslaved men took advantage of this arrangement and provided extra food and clothing for their loved ones."), _c('a', {
    attrs: {
      "id": "rch1en91"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" In the rice mills and sugar refineries, tasks were often assigned on a gendered basis: men performed heavy tasks; women and children placed sugar cane on conveyor belts, fed the cars, carted trash, washed, and boiled juice."), _c('a', {
    attrs: {
      "id": "rch1en92"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Salt firms utilized a predominantly male workforce. Of the workers who labored in the salt industries of Kanawha, Virginia, 75 percent were men. Women often worked as cooks."), _c('a', {
    attrs: {
      "id": "rch1en93"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" Hemp production was dirty and laborious and almost entirely performed by slaves. Men undertook most of the work in the fields because, in the words of one observer, “None but our strong, able negro men can handle it to advantage.” Indeed, one commentator asserted, “Negro women cannot labor at hemp at all and are scarcely worth anything.” Most of the factory workforce was male; women cooked and performed housekeeping duties for enslaved people who were housed and fed on the premises."), _c('a', {
    attrs: {
      "id": "rch1en94"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" Perhaps the only industry that utilized predominantly women in its enslaved workforce—for reasons of cost and control—was the textile industry."), _c('a', {
    attrs: {
      "id": "rch1en95"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many enslaved men who worked in city factories lived in distinct male homosocial spaces. It was common for slaves working in the city to live "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("with their masters or agents or to find their own accommodation, which prevented the concentration of slaves free from white supervision. However, some slaves who worked in the large tobacco and iron enterprises were housed in large, men-only dormitories and barracks that contained anywhere from ten to a hundred slaves. According to historian Richard Wade, this arrangement was not uncommon in cities such as Richmond and Charleston. Wade suggests that the greater instability of slavery in the towns meant that relationships between the sexes were weak and rarely permanent. As one observer commented, “husbands and wives most commonly belong to different families. Laboring apart, and having their meals apart, the domestic bonds of domestic life are few and weak.” In the absence of such ties, it is conceivable that enslaved urban men turned to each other for practical and emotional support, thus strengthening male solidarity.")]), _c('a', {
    attrs: {
      "id": "rch1en96"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Enslaved men who worked in southern industries labored in markedly homosocial masculine spaces and developed their own masculine work culture. These men lived interdependent lives—living, sleeping, and working in close proximity to one another. In many cases, they were forced to live and work disconnected from their families and regular plantation life.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("Skilled Work")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Apart from household work, midwifery, nursing, and seamstress roles, skilled occupations were almost exclusively held by enslaved men, who worked as carpenters, blacksmiths, bricklayers, coopers, cobblers, ironsmiths, masons, tanners, and wheelwrights. Men used these jobs to rank and order themselves in the homosocial sphere and wider community. Using the words of Deborah Gray White, these skilled jobs “created a yardstick” through which enslaved men could “measure their achievements.”"), _c('a', {
    attrs: {
      "id": "rch1en97"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Men took pride in these roles and enjoyed benefits that were simply unavailable to field slaves. Skilled slaves created their own masculine work culture; they served as important mentors and masculine role models to younger boys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On most farms and plantations throughout the South, the enslaved workforce was too small to assign permanent skilled roles. On small and medium plantations, skilled slaves usually performed specialized tasks when required and then returned to the field. To permanently allocate formal labor divisions between house and field slaves, planters needed well over fifty slaves."), _c('a', {
    attrs: {
      "id": "rch1en98"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" But even on large plantations, during the busy planting and harvesting seasons, owners did not hesitate to send skilled and semiskilled "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("slaves into the fields.")]), _c('a', {
    attrs: {
      "id": "rch1en99"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" Historians calculate that approximately 25 percent of slaves were skilled—the remainder worked as field laborers. Skilled work included household, artisanal, mechanical, and transportation work; working with livestock; and midwifery and nursing roles."), _c('a', {
    attrs: {
      "id": "rch1en100"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The very concept of “skill,” however, has been debated by historians. For example, Charles Joyner has asserted, “One could plausibly argue that virtually all the field hands on a rice plantation should be classified as skilled laborers, in view of the level of competence required in rice culture.”"), _c('a', {
    attrs: {
      "id": "rch1en101"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" Recently, Daina Berry has emphasized that “agricultural workers (male and female alike) acquired skills crucial to the production of staple crops; therefore, in some instances, the connection between field and unskilled labor is inappropriate.”"), _c('a', {
    attrs: {
      "id": "rch1en102"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" For the purposes of this discussion, though, “skilled labor” refers to the non-agricultural skilled tasks, chiefly artisanal work, performed by enslaved men away from the field. In spite of some variations, on large plantations throughout the South, the experiences of skilled slaves were generally the same: planters selected enslaved men to work as artisans, mechanics, animal minders, drivers, and transporters and women as midwives, nurses, and domestic servants."), _c('a', {
    attrs: {
      "id": "rch1en103"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dey had special mens on de plantation for all de special wuk,” recalled former slave Bill Heard."), _c('a', {
    attrs: {
      "id": "rch1en104"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" On large plantations, enslaved men worked in a variety of skilled roles: carpenters, blacksmiths, bricklayers, coopers, cobblers, ironsmiths, masons, tanners, and wheelwrights. Skilled slaves were valuable assets for slaveholders; as one former slave recalled, a carpenter or blacksmith “always was worth more money dan a field hand.”"), _c('a', {
    attrs: {
      "id": "rch1en105"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Accordingly, masters knew that if slaves learned trades, it would increase their values."), _c('a', {
    attrs: {
      "id": "rch1en106"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" Slave owners were profit-motivated individuals; when they were not employing the services of these men on their own plantations, they hired them out for money to other plantations in the neighborhood. James Henry Stith recalled that his enslaved father was a carpenter “of the first class” and was constantly in demand. When he wasn’t working for his master, W. W. Simpson, “he was working for the next big farmer, and then the next one, and then the next one … sometimes he worked a contract.” In this way, the master received wages for Stith’s father’s work. According to Stith, his father’s time “was valuable.”"), _c('a', {
    attrs: {
      "id": "rch1en107"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Skilled men gained respect from both the black and white community. Duncan Heyward recollected that the blacksmith Caesar Pencile, who worked on his family’s rice plantation, was “respected by master and overseer alike.”"), _c('a', {
    attrs: {
      "id": "rch1en108"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Likewise, Elizabeth W. Allston Pringle, daughter of Robert F. W. Allston, owner of one of the largest plantations "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("in South Carolina, recalled that on Chicora Wood plantation the head carpenter “was a great person … so dignified.”")]), _c('a', {
    attrs: {
      "id": "rch1en109"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" Margaret Devereux, the young mistress of a North Carolina plantation, fondly described the work of one of the enslaved plantation carpenters as “beautiful.” According to her, the head carpenter, Jim, who was also a preacher, was “highly thought of by both white and back.”"), _c('a', {
    attrs: {
      "id": "rch1en110"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within slave communities, social status was not dependent on what enslaved laborers could do for the white slaveholding class. Rather, as John W. Blassingame has argued, “slaves reserved the top rungs of the social ladder for those blacks who performed services for other slaves rather than for whites.” In Blassingame’s classification system, conjurors, physicians, midwives, preachers, teachers, and entertainers were placed at the top. The “middle class” chiefly consisted of self-employed slaves, mobile slaves, and artisans, while the “lower class” was made up of ordinary field hands and short-term live-in house servants. Exploitative drivers, live-in house servants with a long tenure, voluntary concubines, and informants were regarded as the lowest of the low."), _c('a', {
    attrs: {
      "id": "rch1en111"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" WPA testimony indicates that enslaved male artisans employed their skills for the benefit of their families and others and were, accordingly, afforded a great deal of respect from both enslaved men and women. Mark Oliver recalled the “pretty smart one among the slaves” who was the plantation carpenter. He marveled at the “beautiful” beds the carpenter made for the enslaved community: “Every one of them had a tester, like a canopy over it.”"), _c('a', {
    attrs: {
      "id": "rch1en112"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" Luke Wilson recalled that his uncle, the carpenter on his plantation, “kept the houses in good shape,” ensuring that slaves “had good comfortable quarters.”"), _c('a', {
    attrs: {
      "id": "rch1en113"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Enslaved artisans directly employed their skills for the benefit of their own families. George Washington Browning, whose father was a shoemaker, recalled, “many a night I have held the light for my father to see by to make shoes for us. He often give me a dime.”"), _c('a', {
    attrs: {
      "id": "rch1en114"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" Former slaves fondly recollected the occasions their fathers made furniture for their family."), _c('a', {
    attrs: {
      "id": "rch1en115"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" Zach Herndon declared, “All us had, was a table, benches and beds. And my paw made dem.”"), _c('a', {
    attrs: {
      "id": "rch1en116"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" Another boasted, “My pappy made all de furniture dat went in our house an’ it were might’ good furniture too.”"), _c('a', {
    attrs: {
      "id": "rch1en117"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many enslaved artisans provided for their families from the proceeds of hiring-out arrangements. Some planters presented these men with gifts for their services, such as food, cloth, and other items, which could be used for their families, bartered, or sold for cash within slave communities."), _c('a', {
    attrs: {
      "id": "rch1en118"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" It was not unusual for slaveholders to give male artisans small portions "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("of the money they made for their owners as a result of their hire. J. H. Curry described his father as a “fine carpenter.” “Sometimes he went off and worked and would bring the money back to his master, and his master would give him some for himself.”")]), _c('a', {
    attrs: {
      "id": "rch1en119"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" Men used this money to provide for their families. Harriet Jacobs disclosed, at the start of her slave narrative, that she felt “shielded growing up in a comfortable home” where her father was an “intelligent and skilful” carpenter who brought home wages for his family."), _c('a', {
    attrs: {
      "id": "rch1en120"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" Such accounts confirm that skilled slaves performed the masculine role of provider for their families and gained respect accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is particularly striking in the WPA narratives, however, is the relationship shared between father and son. Skilled work enabled them to spend time with one another, teaching and learning skills. Carey Davenport, for instance, proudly proclaimed that his father was a blacksmith, a carpenter, and a wheelwright—a “valuable man” on the plantation. Davenport boasted, “He make the bes’ Carey plows in that part of the country.” “He uster be specially good at makin’ the mould board (turning shear). The mould board was made out of hardwood. It had a iron point what my pa make.” Davenport listed many other examples of his father’s skills: “He make horseshoes, nails and anything make out of iron, and he shod the horses and the mules. He uster make spinnin’ wheels and parts of looms … he make wheels, make the hub and put the spokes in and set up the whole wagon wheel.” Davenport’s father also made oxen yokes: “He shape up the beam and make the bows. He holler out a place in a log and put the wood he goin’ to make the bow outer in it. There was two pieces of wood standin’ up about the middle of the bow. They put a lever on it and ben’ up one end and put a clevis on it. Den he put the lever on the other end and put the clevis on that and that kep’ it bent. Then he let it season and git the shape. I help him make many a one.”"), _c('a', {
    attrs: {
      "id": "rch1en121"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" The detail of knowledge Davenport evinces is significant: it demonstrates that he spent many occasions with his father and picked up extensive knowledge of his father’s skills. Indeed, rather than learning their trade from whites, by the mid-eighteenth century, the majority of enslaved artisans acquired their skills from other slaves."), _c('a', {
    attrs: {
      "id": "rch1en122"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" In the antebellum South, these skills were passed down from one generation to the next, typically from father to son. Many WPA interviewees revealed that they learned skills from their fathers; Morris Hillyer, for example, learned carpentry from his father."), _c('a', {
    attrs: {
      "id": "rch1en123"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" Likewise, James Henry Stith followed his father’s occupation of carpentry and made a living out of it for fifty-four years."), _c('a', {
    attrs: {
      "id": "rch1en124"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Learning a trade enabled men to forge closer father-son "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("ties. If skilled artisans were separated from their sons, they may have “adopted” other youngsters to teach their skills to. In this sense, apprenticeships between older and younger men could have operated similarly to kin ties. By passing skills down, enslaved men affirmed intergenerational masculine bonds in the slave community. Elders served as role models for boys and young men. Learning trades also took place in masculine spaces; with women working in the field, or as domestic servants, the workshops located on large plantations were exclusively masculine worlds. Margaret Devereux, for instance, recalled that on her plantation in North Carolina, four men—Jim, Austin, Bill, and Frank—worked together in the “carpenter’s shop.”")]), _c('a', {
    attrs: {
      "id": "rch1en125"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On large plantations, in industry, and in skilled work, enslaved men often labored together in markedly homosocial spaces, where they created their own distinctive masculine work culture and identity. On large plantations, in sex-segregated gangs, enslaved men usually undertook the most physically arduous tasks—plowing; ditch-digging; and chopping, mauling, and hauling wood—while women grubbed and hoed. Although enslaved women sometimes plowed and chopped wood in separate work gangs, enslaved men considered these jobs masculine."), _c('a', {
    attrs: {
      "id": "rch1en126"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#ch1en126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" Enslaved men who worked in certain southern industries—naval stores or lumber—or those working on the railroads and canals, lived, slept, and worked together in male camps, separated from their families for long durations. These men performed particularly dangerous jobs. They relied on each other for support and friendship; cooperation and interdependence characterized their everyday lives. Both the free and enslaved communities highly respected artisanal work. Enslaved artisans took pride in their work; it was an avenue through which they could forge their own unique work culture.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d52d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 78
// module chunks = 0